// Aktivitäts-Ping (NT-OFFLINE-CAP-01) — meldet echte Nutzer-Interaktion (Klick/Tap/Keydown) ans
// Backend, throttled auf 1×/min. Feuert NIEMALS aus Hintergrund-Polling/Timern — nur aus echten
// Browser-Events. Basis für den aktivitätsbasierten Offline-Cap (siehe apps/backend/src/utils/
// offline-cap.utils.ts) — Hintergrund-Polling darf lastActiveAt nicht aktualisieren, sonst hält ein
// offener, ignorierter Tab den Spieler ewig "aktiv" und der Cap greift nie.

import { api } from './api.js';
import { gameState } from '../state/gameState.js';

const PING_THROTTLE_MS = 60_000;

let lastPingAt = 0;
let initialized = false;

function firePing(): void {
  if (!gameState.isAuthenticated()) return;

  const now = Date.now();
  if (now - lastPingAt < PING_THROTTLE_MS) return;
  lastPingAt = now;

  void api.post('/activity/ping', {}).catch(() => {
    // Fehlschlag ist unkritisch – nächste echte Interaktion versucht es erneut.
  });
}

/** Einmalig beim App-Start aufrufen (main.ts). Registriert globale, passive Event-Listener. */
export function initActivityPing(): void {
  if (initialized) return;
  initialized = true;

  const options: AddEventListenerOptions = { passive: true, capture: true };
  window.addEventListener('click', firePing, options);
  window.addEventListener('touchstart', firePing, options);
  window.addEventListener('keydown', firePing, options);
}
